import React, { useMemo } from 'react';
import { Layout, Typography, Space } from 'antd';
import { SmileOutlined } from '@ant-design/icons';

const { Header: AntHeader } = Layout;
const { Title, Text } = Typography;

function getGreeting(): string {
  const hour = new Date().getHours();
  if (hour < 11) return 'Chào buổi sáng ☀';
  if (hour < 14) return 'Chào buổi trưa';
  if (hour < 18) return 'Chào buổi chiều';
  return 'Chào buổi tối 🌙';
}

const Header: React.FC = () => {
  const greeting = useMemo(getGreeting, []);

  return (
    <>
      <AntHeader className="app-header">
        <div className="app-header-inner">
          <Space align="center" size={14}>
            <div className="app-header-icon-wrap">
              <SmileOutlined className="app-header-icon" />
            </div>
            <div>
              <Title level={3} className="app-header-title">
                Góc Bình Yên
              </Title>
              <Text className="app-header-subtitle">
                Một khoảng lặng ấm áp giữa ngày bận rộn
              </Text>
            </div>
          </Space>
          <Text className="app-header-greeting">{greeting}</Text>
        </div>
      </AntHeader>
      <svg
        className="app-wave"
        viewBox="0 0 1200 60"
        preserveAspectRatio="none"
        aria-hidden="true"
      >
        <path
          d="M0,32 C150,60 350,4 600,28 C850,52 1050,8 1200,30 L1200,60 L0,60 Z"
          fill="#fffbf3"
        />
      </svg>
    </>
  );
};

export default Header;
